package br.com.htms.inspeccaocampo.platform

actual object LiveNrCamera {
    actual fun isSupported(): Boolean = false
    actual fun open(onJpeg: (ByteArray) -> Unit) = Unit
    actual fun close() = Unit
}
